import { RootState } from '@/App/store';

export const selectUserDeleteStep = (state: RootState) => state.user.deleteStep;
